module.exports = __webpack_public_path__ + "img/neg-parking.e34880cd.png";